/**
 * Confetti - Animation CSS-only de confettis (pas de dépendance externe)
 * Utilisée à la fin de l'évaluation et de la séance HIIT
 */

import React, { useEffect, useState } from 'react';

const COLORS = ['#FF6B2B', '#EF4444', '#22C55E', '#3B82F6', '#FBBF24', '#A855F7', '#EC4899'];

function ConfettiPiece({ index, total }) {
  const color = COLORS[index % COLORS.length];
  const left = Math.random() * 100;
  const delay = Math.random() * 0.8;
  const duration = 1.5 + Math.random() * 1.5;
  const size = 6 + Math.random() * 6;
  const rotation = Math.random() * 360;

  return (
    <div
      style={{
        position: 'absolute',
        top: -10,
        left: `${left}%`,
        width: size,
        height: size * (Math.random() > 0.5 ? 1 : 0.6),
        backgroundColor: color,
        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
        transform: `rotate(${rotation}deg)`,
        animation: `confetti-fall ${duration}s ease-in ${delay}s forwards`,
        opacity: 0,
      }}
    />
  );
}

export function Confetti({ active = true, duration = 3000 }) {
  const [show, setShow] = useState(active);

  useEffect(() => {
    if (active) {
      setShow(true);
      const timer = setTimeout(() => setShow(false), duration);
      return () => clearTimeout(timer);
    }
  }, [active, duration]);

  if (!show) return null;

  return (
    <>
      <style>{`
        @keyframes confetti-fall {
          0% { opacity: 1; transform: translateY(0) rotate(0deg); }
          100% { opacity: 0; transform: translateY(85vh) rotate(720deg); }
        }
      `}</style>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 999,
          pointerEvents: 'none',
          overflow: 'hidden',
        }}
      >
        {Array.from({ length: 50 }).map((_, i) => (
          <ConfettiPiece key={i} index={i} total={50} />
        ))}
      </div>
    </>
  );
}
